import React, { useEffect, useState } from 'react';

import { useSubscription } from 'react-stomp-hooks';
import colorsVars from 'styles/colors.module.scss';

import { useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useUserHook from 'hooks/useUserHook';

import { useQueryUnreadNotificationsCounter } from 'api/queries/getUnreadNotificationsCounter.query';

import { Badge } from 'components/common/Badge/badge';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';

import classes from 'components/App/AuthenticateLayout/Header/Notification/NotificationBell/NotificationBell.module.scss';
import { CustomizedTooltip } from 'components/common';

const { headerIconColor } = colorsVars;
interface INotificationBell {
    onClick: () => void;
}

const NotificationBell = ({ onClick }: INotificationBell) => {
    const { data: UnreadNotificationsCounter } = useQueryUnreadNotificationsCounter();
    const { email } = useUserHook();
    const { handleSnackBar } = useCustomSnackBar();
    const [notificationsCount, setNotificationsCount] = useState<number>(0);

    /**
     * web socket subscribe to notification count
     */
    useSubscription(email ? [`/topic/${email}.notifications.push`] : [], (response) => {
        const { type, message } = JSON.parse(response.body);
        if (type === 'NotificationsCount') {
            setNotificationsCount(message);
        }
        if (type === 'NewNotificationArrivedAndCount') {
            setNotificationsCount(message.count);
            handleSnackBar(
                <>
                    <div>
                        New Notification from {message.notification.producer_full_name}: {message.notification.message}
                    </div>
                    <div className={classes.link} onClick={onClick}>
                        See all notifications
                    </div>
                </>,
                'info',
            );
        }
    });

    /**
     * regular query to get notifications count on mount due to BE queue handling
     */
    useEffect(() => {
        setNotificationsCount(Number(UnreadNotificationsCounter));
    }, [UnreadNotificationsCounter]);

    return (
        <div className={classes.notificationBell} id={'NotificationBell'}>
            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Bottom}
                tooltipContent={`Notifications`}
                triggerElement={
                    <Icon name={'notification-bell'} size={`2.4rem`} color={headerIconColor} onClick={onClick} />
                }
            />
            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Bottom}
                tooltipContent={`Notifications`}
                triggerElement={<Badge count={notificationsCount} />}
            />
        </div>
    );
};

export default NotificationBell;
